import React, { useRef, useState, useCallback, useEffect } from "react";
import { MoveLeft } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Dropdown,
  Button,
  Spinner,
  ToastContainer,
  Toast,
} from "react-bootstrap";
import DOMPurify from "dompurify";
import ErrorExtractor from "../common/error_extractor";
import CommonDropdown from "../common/common_dropDown";
import { ReactComponent as InfoIc } from "../../assets/svg/info_ic.svg";
import {
  submitPOAPI,
  updatePOAPI,
  getPOEditApi,
  getProductDetailsApi,
  getVendorProductDetailsApi,
  submitPurchaseRequestAPI,
} from "./pr-api";
import addImage from "../../assets/svg/add-image.svg";
import { X } from "lucide-react"; // Close icon
import upload from "../../assets/svg/upload.svg";
import attachment from "../../assets/png/attachment.png";
import download from "../../assets/svg/download.svg";
import closeAttachment from "../../assets/svg/close-red.svg";
import { Sidebar } from "../common/Sidebar";
import { Navbar } from "../common/Navbar";
import DatePicker from "react-datepicker";
import { Calendar } from "lucide-react";
import deleteIcon from "../../assets/svg/delete-po.svg";
import profileIc from "../../assets/png/profile-ic.png";
import numberFormat from "../common/number-format";
export const PurchaseRequestCreate = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const adminUrl = process.env.REACT_APP_ADMIN_API_URL;

  const location = useLocation();
  const navigate = useNavigate();
  const { id } = location.state || {};
  const from = location.state?.from;
  const vendor = location.state;
  const [isLoader, setIsLoader] = useState(false);
  const [productList, setProductList] = useState([]);
  const [removedProductList, setRemovedProductList] = useState([]);
  const [isConfirmRequest, setConfirmRequest] = useState(false);
  const [vendorProductList, setVendorProductList] = useState([]);

  const handleBack = () => {
    if (from === "vendor") {
      navigate("/viewVendor", {
        state: {
          activeTab: "request",
          id: location.state?.vendorId,
        },
      });
    } else {
      navigate("/pr"); // product list
    }
  };
  useEffect(() => {
    console.log("vendor", vendor)
    if (id != null) {
      getPurchaseOrderEdit(id);
    } else {
      setProductList([
        {
          id: 0,
          proceed: null,
          product: null,
          product_code: null,
          product_img: null,
          unit: null,
          date: null,
          quantity: 0,
        },
      ]);
    }
  }, [id]);

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  const [projectOption, setProjectOption] = useState(null);
  const [paymentTypeOption, setPaymentTypeOption] = useState(null);
  const [vendorOption, setVendorOption] = useState(null);
  const [currencyOption, setCurrencyOption] = useState(null);
  const [description, setDescription] = useState("");

  const [errorMsg, setErrorMsg] = useState({
    products: "",
    vendors: "",
  });
  const [groupedError, setGroupedError] = useState({});

  const getProductDetails = async (id, index) => {
    try {
      const response = await getProductDetailsApi(id);

      if (response.data.success === true) {
        const productDetail = response.data.product ?? {};
        const productTemp = [...productList];
        productTemp[index]["product_code"] = productDetail.code ?? "";
        productTemp[index]["product_img"] = productDetail.image ?? "";
        setProductList(productTemp);
      } else {
      }

      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getVendorProductDetails = async () => {
    if (isLoader) return;
    setIsLoader(true);
    try {
      const updatedData = productList
        .filter((item) => item.product !== null)
        .map((item) => ({
          id: item.product != null ? item.product.value : "",
          unit_id: item.unit != null ? item.unit.value : "",
          quantity: item.quantity,
          date:
            item.date != null && item.date !== ""
              ? item.date.toLocaleDateString("en-CA")
              : "",
        }));

      const response = await getVendorProductDetailsApi({
        products: updatedData,
      });

      if (response.data.success === true) {
        const vendorProductDetail = response.data?.vendors?.map((item) => ({
          ...item,
          products: item.products?.map((product) => ({
            ...product,
            checked: false,
          })),
        }));
        setVendorProductList(vendorProductDetail);
        setGroupedError({});
        setConfirmRequest(true);
        setErrorMsg({ products: "", vendors: "" });
      } else {
      }
      if (response.status === 400) {
        new Promise((resolve, reject) => {
          const validationTemp = { products: "" };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? "" : value[0];
          });
          setErrorMsg(validationTemp);

          const groupedErrorTemp = {};
          Object.entries(response.data.error).forEach(([key, value]) => {
            // match tickets.index.field
            const match = key.match(/^products\.(\d+)\.(.+)$/);

            if (match) {
              const index = match[1]; // e.g. "0"
              const field = match[2]; // e.g. "closing_date"

              if (!groupedErrorTemp[index]) groupedErrorTemp[index] = {};
              groupedErrorTemp[index][field] = value;
            }
          });
          setGroupedError(groupedErrorTemp);
        });
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsLoader(false);
    }
  };

  const submitRequest = async () => {
    if (isLoader) return;
    setIsLoader(true);
    try {
      const updatedData = vendorProductList
        .filter(
          (item) =>
            item.products.every((product) => product.checked === false) !== true
        )
        .map((item) => ({
          ...item,
          products: item.products?.filter((item) => item.checked === true),
        }));

      const response = await submitPurchaseRequestAPI({
        vendors: updatedData,
      });

      if (response.data.success === true) {
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();

        handleBack();
      } else {
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();
      }

      if (response.status === 400) {
        new Promise((resolve, reject) => {
          const validationTemp = { products: "", vendors: "" };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? "" : value[0];
          });
          setErrorMsg(validationTemp);

          const groupedErrorTemp = {};
          Object.entries(response.data.error).forEach(([key, value]) => {
            // match tickets.index.field
            const match = key.match(/^vendors\.(\d+)\.products\.(\d+)\.(.+)$/);

            if (match) {
              const vendorIndex = match[1]; // "0"
              const productIndex = match[2]; // "0"
              const field = match[3]; // "qty"

              if (!groupedErrorTemp[vendorIndex]) {
                groupedErrorTemp[vendorIndex] = {};
              }
              if (!groupedErrorTemp[vendorIndex]["products"]) {
                groupedErrorTemp[vendorIndex]["products"] = [];
              }
              if (!groupedErrorTemp[vendorIndex]["products"][productIndex]) {
                groupedErrorTemp[vendorIndex]["products"][productIndex] = {};
              }
              groupedErrorTemp[vendorIndex]["products"][productIndex][field] =
                value;
            }
          });
          console.log(groupedErrorTemp);
          setGroupedError(groupedErrorTemp);
        });
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsLoader(false);
    }
  };

  const getPurchaseOrderEdit = async (id) => {
    try {
      const response = await getPOEditApi(id);

      if (response.data.success === true) {
        const poDetail = response.data.order ?? {};

        setVendorOption({
          value: poDetail.vendor_id ?? "",
          label: poDetail.vendor_name ?? "",
        });
        setCurrencyOption({
          value: poDetail.currency_id ?? "",
          label: poDetail.currency_name ?? "",
        });
        setPaymentTypeOption({
          value: poDetail.payment_type ?? "",
          label: poDetail.payment_type ?? "",
        });
        setProjectOption({
          value: poDetail.project_id ?? "",
          label: poDetail.project_name ?? "",
        });
        setDescription(poDetail.description ?? "");

        const productTemp = [];
        poDetail.products.forEach((item, index) => {
          productTemp.push({
            id: item.id,
            product: { value: item.product_id, label: item.name },
            product_code: item.code,
            product_img: item.image,
            unit: { value: item.unit_id, label: item.unit_name },
            date:
              item.date != null && item.date !== ""
                ? new Date(item.date)
                : null,
            quantity: item.quantity,
          });
        });
        setProductList(productTemp);
      } else {
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getErrorMsg = (index, field) => {
    if (field === "id") {
      if (groupedError[index] != null) {
        if (groupedError[index].id != null) {
          return (
            groupedError[index].id[0]?.replace(
              `products.${index}.id`,
              "product"
            ) ?? ""
          );
        }
      }
    }
    if (field === "exception") {
      if (groupedError[index] != null) {
        if (groupedError[index].exception != null) {
          return (
            groupedError[index].exception[0]?.replace(
              `products.${index}.exception`,
              "exception"
            ) ?? ""
          );
        }
      }
    }
    if (field === "unit_id") {
      if (groupedError[index] != null) {
        if (groupedError[index].unit_id != null) {
          return (
            groupedError[index].unit_id[0]?.replace(
              `products.${index}.unit_id`,
              "unit"
            ) ?? ""
          );
        }
      }
    }

    if (field === "date") {
      if (groupedError[index] != null) {
        if (groupedError[index].date != null) {
          return (
            groupedError[index].date[0]?.replace(
              `products.${index}.date`,
              "date"
            ) ?? ""
          );
        }
      }
    }

    if (field === "quantity") {
      if (groupedError[index] != null) {
        if (groupedError[index].quantity != null) {
          return (
            groupedError[index].quantity[0]?.replace(
              `products.${index}.quantity`,
              "quantity"
            ) ?? ""
          );
        }
      }
    }

    if (field === "unit_without_tax") {
      if (groupedError[index] != null) {
        if (groupedError[index].unit_without_tax != null) {
          return (
            groupedError[index].unit_without_tax[0]?.replace(
              `products.${index}.unit_without_tax`,
              "unit price"
            ) ?? ""
          );
        }
      }
    }

    if (field === "tax_percentage") {
      if (groupedError[index] != null) {
        if (groupedError[index].tax_percentage != null) {
          return (
            groupedError[index].tax_percentage[0]?.replace(
              `products.${index}.tax_percentage`,
              "tax percentage"
            ) ?? ""
          );
        }
      }
    }

    return "";
  };
  const getVendorRequestErrorMsg = (vIndex, index, field) => {
    if (field === "qty") {
      if (groupedError[vIndex] != null) {
        if (groupedError[vIndex].products != null) {
          if (groupedError[vIndex].products[index].qty != null) {
            return (
              groupedError[vIndex].products[index].qty[0]?.replace(
                `vendors.${vIndex}.products.${index}.qty`,
                "quantity"
              ) ?? ""
            );
          }
        }
      }
    }
  };
  return (
    <div className="d-flex flex-column flex-xl-row">
      <Sidebar currentfile="RFQ" />
      <div
        className="bg-half-white"
        style={{
          width: "calc(100% - clamp(218px, 12%, 251px))",
          background: "#F5F8FA",
        }}
      >
        <Navbar pageTitle="RFQ" />
        <div>
          <div className="bg-white px-2 d-flex align-items-center justify-content-between">
            <div className="d-flex gap-3 my-3">
              <MoveLeft
                className="cursor-pointer"
                onClick={() => {
                  handleBack();
                }}
              />
              <p className="fw-semibold m-0">New RFQ</p>
            </div>
            <div className="d-flex gap-3">
              {/* <Button
                className="cursor-pointer bg-white rounded-pill px-4 py-2  btn-border-grey fs-15 fw-500"
                style={{ border: "1px solid #D4DDE7", color: "#212129" }}
                onClick={() => {
                  navigate(-1);
                }}
              >
                Cancel
              </Button>
              <Button
                className={`cursor-pointer dark-purple-btn ${
                  isLoader ? "disabled-btn" : ""
                } rounded-pill py-2 px-4 d-flex justify-content-center align-items-center`}
                onClick={
                  isLoader === false
                    ? () => {
                        submitForm();
                      }
                    : () => {}
                }
                style={{ minWidth: "100px" }}
              >
                {isLoader ? (
                  <Spinner animation="border" size="sm" />
                ) : id != null ? (
                  "Update"
                ) : (
                  "Save"
                )}
              </Button> */}

              {isConfirmRequest === false && (
                <Button
                  className={`cursor-pointer border-0 rounded-pill position-relative d-flex justify-content-center align-items-center ${isLoader ? "disabled-btn" : ""
                    }`}
                  onClick={!isLoader ? getVendorProductDetails : undefined}
                  style={{
                    minWidth: "100px",
                    height: "40px",
                    background: "#4EBD7E",
                    padding: 0,
                  }}
                >
                  {/* Text (always takes space) */}
                  <span
                    style={{
                      lineHeight: "40px",
                      opacity: isLoader ? 0 : 1,
                      visibility: isLoader ? "hidden" : "visible",
                    }}
                  >
                    Request
                  </span>

                  {/* Spinner overlay */}
                  {isLoader && (
                    <Spinner
                      animation="border"
                      size="sm"
                      className="position-absolute"
                    />
                  )}
                </Button>


              )}
              {isConfirmRequest === true && (
                <Button
                  className="cursor-pointer bg-white rounded-pill px-4 py-2  btn-border-grey fs-15 fw-500"
                  style={{ border: "1px solid #D4DDE7", color: "#212129" }}
                  onClick={() => {
                    setConfirmRequest(false);
                  }}
                >
                  Edit
                </Button>
              )}
              {isConfirmRequest === true && vendorProductList.length > 0 && (
                <Button
                  className={`cursor-pointer border-0  ${isLoader ? "disabled-btn" : ""
                    } rounded-pill py-2 px-4 d-flex justify-content-center align-items-center`}
                  onClick={
                    isLoader === false
                      ? () => {
                        submitRequest();
                      }
                      : () => { }
                  }
                  style={{ minWidth: "100px", height: "40px", background: "#4F46E5" }}
                >
                  {isLoader ? (
                    <Spinner animation="border" size="sm" />
                  ) : (
                    "Confirm Request"
                  )}
                </Button>
              )}
            </div>
          </div>

          {isConfirmRequest === false && (
            <div className="m-2 bg-white rounded-4 p-3">
              <div className="row">
                <div className="col-12 ">
                  <div className="row">
                    <div className="col-xl-12">
                      <p className="fs-18 fw-600 mb-0">Product </p>
                    </div>
                    <span className="fs-12 fw-400 cardTextRed">
                      {errorMsg.products}
                    </span>

                    <div style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
                      <div
                        className="bg-white rounded-4 mt-3"
                        style={{
                          display: "inline-block",
                          minHeight: "250px",
                          minWidth: "1200px", // ensures scroll if content exceeds viewport
                        }}
                      >
                        {/* Header Row */}
                        <div
                          style={{
                            backgroundColor: "#F2F2F2",
                            display: "grid",
                            gridTemplateColumns: productList.some((_, index) =>
                              getErrorMsg(index, "exception")
                            )
                              ? "100px 200px 160px 120px 174px 120px 140px 100px 180px 160px 80px"
                              : "200px 160px 120px 174px 120px 140px 100px 180px 160px 80px",
                            padding: "10px 16px",
                            borderBottom: "1px solid #EBEBEB",
                          }}
                        >
                          {productList.some((_, index) =>
                            getErrorMsg(index, "exception")
                          ) && (
                              <div className="fs-13 fw-700 textcolor">
                                Proceed
                              </div>
                            )}
                          <div className="fs-13 fw-700 textcolor">
                            Product Name
                          </div>
                          <div className="fs-13 fw-700 textcolor">
                            Product ID
                          </div>
                          <div className="fs-13 fw-700 textcolor">Unit</div>
                          <div className="fs-13 fw-700 textcolor">Expected</div>
                          <div className="fs-13 fw-700 textcolor">Quantity</div>

                          <div className="fs-13 fw-700 textcolor"></div>
                        </div>

                        {/* Example Data Rows */}
                        {productList.map((row, index) => {
                          return (
                            <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: productList.some(
                                  (_, index) => getErrorMsg(index, "exception")
                                )
                                  ? "100px 200px 160px 120px 174px 120px 140px 100px 180px 160px 80px" // with error column
                                  : "200px 160px 120px 174px 120px 140px 100px 180px 160px 80px", // normal
                                padding: "10px 16px",
                                borderBottom: "1px solid #EBEBEB",
                              }}
                            >
                              <div className="pe-3 py-1">
                                {" "}
                                <CommonDropdown
                                  apiUrl={`${apiUrl}get_product?vendor_id=${vendor?.vendorId ?? ""}&term=`}
                                  placeholder="Select"
                                  value={row.product}
                                  onSelect={(item) => {
                                    productList[index]["product"] = item;
                                    setProductList(productList);
                                    getProductDetails(item.value, index);
                                  }}
                                />
                                <span className="fs-12 fw-400 cardTextRed">
                                  {getErrorMsg(index, "id")}
                                </span>
                              </div>
                              <div className="pe-3 py-1">
                                {" "}
                                <div
                                  className="px-1 d-flex align-items-center"
                                  style={{
                                    minWidth: "134px",
                                    height: "36px",
                                    borderRadius: "8px",
                                    background: "#F8F8F8",
                                    border: "1px solid #EBEBEB",
                                  }}
                                >
                                  {row.product_code}
                                </div>
                              </div>
                              <div className="pe-3 py-1">
                                <CommonDropdown
                                  apiUrl={`${apiUrl}get_uom?term=`}
                                  placeholder="Select"
                                  value={row.unit}
                                  onSelect={(item) => {
                                    productList[index]["unit"] = item;
                                    setProductList(productList);
                                  }}
                                />
                                <span className="fs-12 fw-400 cardTextRed">
                                  {getErrorMsg(index, "unit_id")}
                                </span>
                              </div>
                              <div className="pe-3 py-1">
                                {" "}
                                <div style={{ minWidth: "164px" }}>
                                  <DatePicker
                                    selected={row.date}
                                    onChange={(date) => {
                                      const productTemp = [...productList];
                                      productTemp[index]["date"] = date;
                                      setProductList(productTemp);
                                    }}
                                    dateFormat="yyyy-MM-dd"
                                    customInput={
                                      <button
                                        style={{
                                          color: "#8790A1",
                                          width: "100%",
                                        }}
                                        className="w-100 btn-border-grey form-control vehicle-form-input bg-white rounded-3 px-3 py-2 d-flex justify-content-between align-items-center gap-2"
                                      >
                                        {row.date ? (
                                          row.date
                                            .toLocaleDateString("en-GB")
                                            .replace(/\//g, "-")
                                        ) : (
                                          <span style={{ color: "#8790A1" }}>
                                            dd-mm-yyyy
                                          </span>
                                        )}
                                        <Calendar size={16} />
                                      </button>
                                    }
                                  />
                                </div>
                                <span className="fs-12 fw-400 cardTextRed">
                                  {getErrorMsg(index, "date")}
                                </span>
                              </div>
                              <div className="pe-3 py-1">
                                {" "}
                                <input
                                  type="text"
                                  className="form-control rounded-3 vendor-form-input"
                                  id={`Quantity` + index}
                                  placeholder="Enter here"
                                  value={row.quantity}
                                  onChange={(e) => {
                                    const productTemp = [...productList];
                                    productTemp[index]["quantity"] =
                                      e.target.value
                                        .replace(/[^0-9.]/g, "")
                                        .replace(/(\..*)\./g, "$1");
                                    setProductList(productTemp);
                                  }}
                                  style={{
                                    borderColor:
                                      getErrorMsg(index, "quantity") !== ""
                                        ? "red"
                                        : "#EBEBEB",
                                  }}
                                />{" "}
                                <span className="fs-12 fw-400 cardTextRed">
                                  {getErrorMsg(index, "quantity")}
                                </span>
                              </div>

                              <div className="sticky-col">
                                <div
                                  style={{
                                    cursor: "pointer",
                                    marginTop: "14px",
                                  }}
                                  onClick={() => {
                                    if (row.id !== null && row.id !== "") {
                                      setRemovedProductList([
                                        ...removedProductList,
                                        row.id,
                                      ]);
                                    }
                                    const productListTemp = [...productList];
                                    productListTemp.splice(index, 1);
                                    setProductList(productListTemp);
                                  }}
                                  className="mx-2 ps-2 d-flex align-items-center justify-content-center "
                                >
                                  <img src={deleteIcon} alt="delete" />
                                </div>
                              </div>
                              <span className="fs-12 fw-400 cardTextRed">
                                {getErrorMsg(index, "exception") !== "" ? (
                                  <>
                                    <InfoIc width={12} height={12} />{" "}
                                    {getErrorMsg(index, "exception")}
                                  </>
                                ) : (
                                  <div></div>
                                )}
                              </span>
                            </div>
                          );
                        })}
                      </div>
                    </div>

                    <div className="col-xl-12 mt-2">
                      <Button
                        className={`cursor-pointer border-0 rounded-pill py-2 px-4 d-flex justify-content-center align-items-center`}
                        onClick={() => {
                          setProductList([
                            ...productList,
                            {
                              id: 0,
                              proceed: null,
                              product: null,
                              product_code: null,
                              product_img: null,
                              unit: null,
                              date: null,
                              quantity: 0,
                            },
                          ]);
                        }}
                        style={{
                          minWidth: "100px",
                          background: "#E6E4FF",
                          color: "#212129",
                          fontWeight: "600",
                          fontSize: "13px",
                        }}
                      >
                        Add product
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {isConfirmRequest === true && errorMsg.vendors && (
            <div className="mx-2 mt-2 px-1">
              <span className="fs-12 fw-400 cardTextRed">
                {errorMsg.vendors}
              </span>
            </div>
          )}

          {isConfirmRequest === true &&
            vendorProductList.map((item, vIndex) => {
              return (
                <div className="m-2 bg-white rounded-4 p-3">
                  <div className="style-justify-start">
                    <div
                      className="bg-white style-justify-center"
                      style={{
                        width: "52px",
                        height: "52px",
                        borderRadius: "100px",
                      }}
                    >
                      <img
                        src={item.image && item.image.trim() !== ""
                          ? item.image
                          : profileIc}
                        alt="vendor"
                        style={{
                          width: "52px",
                          height: "52px",
                          borderRadius: "100px",
                        }}
                      />
                    </div>
                    <div
                      className="ms-2 fs-16 fw-400"
                      style={{ color: "#212129" }}
                    >
                      {item.name}
                    </div>
                  </div>

                  <div style={{ overflowY: "visible" }}>
                    <div className="mt-2  ">
                      <table
                        className="pr-vendor-table"
                        border="1"
                        cellPadding="10"
                        style={{
                          borderCollapse: "collapse",
                          width: "100%",
                        }}
                      >
                        <thead
                          style={{
                            height: "48px",
                            backgroundColor: "#F2F2F2", // ✅ Green background
                            color: "#212129", // ✅ White text
                            fontSize: "13px", // ✅ Font size
                            fontWeight: "700",
                            textAlign: "left",
                          }}
                        >
                          <tr>
                            <th className="ps-2">
                              <input
                                type="checkbox"
                                checked={vendorProductList[vIndex][
                                  "products"
                                ]?.every((product) => product.checked === true)}
                                onChange={(e) => {
                                  console.log(e.target.checked);
                                  const vendorProductTemp = [
                                    ...vendorProductList,
                                  ];
                                  if (e.target.checked) {
                                    const productsTemp = vendorProductTemp[
                                      vIndex
                                    ]["products"].map((product) => ({
                                      ...product,
                                      checked: true,
                                    }));
                                    vendorProductTemp[vIndex]["products"] =
                                      productsTemp;
                                    setVendorProductList(vendorProductTemp);
                                  } else {
                                    const productsTemp = vendorProductTemp[
                                      vIndex
                                    ]["products"].map((product) => ({
                                      ...product,
                                      checked: false,
                                    }));
                                    vendorProductTemp[vIndex]["products"] =
                                      productsTemp;
                                    console.log(productsTemp);
                                    setVendorProductList(vendorProductTemp);
                                  }
                                }}
                                style={{
                                  marginRight: "8px",
                                  marginBottom: "14px",
                                  cursor: "pointer",
                                }}
                              />
                            </th>
                            <th className="ps-2">Product Name</th>
                            <th className="ps-2">Product ID</th>
                            <th className="ps-2">Unit</th>
                            <th className="ps-2">Expected Date</th>
                            <th className="ps-2">Quantity</th>
                          </tr>
                        </thead>
                        <tbody>
                          {item.products?.map((row, index) => (
                            <tr
                              key={row.id}
                              style={{
                                height: "40px",
                                position: "relative",
                                overflow: "visible",
                              }}
                            >
                              <td>
                                <input
                                  type="checkbox"
                                  checked={row.checked ?? false}
                                  onChange={(e) => {
                                    const vendorProductTemp = [
                                      ...vendorProductList,
                                    ]; // create a copy
                                    vendorProductTemp[vIndex]["products"][
                                      index
                                    ]["checked"] = e.target.checked; // update the checked value
                                    setVendorProductList(vendorProductTemp); // update state
                                  }}
                                  style={{
                                    marginRight: "8px",
                                    marginBottom: "14px",
                                    cursor: "pointer",
                                  }}
                                />
                              </td>
                              <td
                                className="px-2 py-1"
                                style={{
                                  position: "relative",
                                  overflow: "visible",
                                }}
                              >
                                {row.name}
                              </td>
                              <td className="px-2 py-1">{row.code ?? ""}</td>
                              <td className="px-2 py-1">
                                {row.unit_label ?? ""}
                              </td>

                              <td className="px-2 py-1">{row.date}</td>

                              <td>
                                {numberFormat(row.quantity)}
                                <span
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: 400,
                                    color: "#FF4444",
                                  }}
                                >
                                  {getVendorRequestErrorMsg(
                                    vIndex,
                                    index,
                                    "qty"
                                  )}
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};
